import React from 'react'
import PropTypes from 'prop-types'
import {Grid} from '@salesforce/retail-react-app/app/components/shared/ui'

import PDComponent from '../../pd-component'

export const PromoGridThreeColumns = ({regions}) => {
    return (
        <Grid
            templateColumns={{base: '1fr', lg: 'repeat(3, 1fr)'}}
            gridTemplateRows={{base: 'repeat(2, 1fr)', lg: '1fr'}}
            aspectRatio={{lg: '1920 / 540'}}
            gap="10px"
            className="promo-grid-three-columns"
        >
            {regions?.map((region) =>
                region?.components?.map((component, index) => (
                    <PDComponent
                        key={`${region.id}-${index}`}
                        component={component}
                        variant="promoGridFourItems" // reuse variant from promoGridFourItems
                    />
                ))
            )}
        </Grid>
    )
}

PromoGridThreeColumns.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        question: PropTypes.string,
                        answer: PropTypes.string
                    })
                })
            )
        })
    ).isRequired
}

export default PromoGridThreeColumns
